import React from 'react';
import LoginForm from '../../components/LoginForm/LoginForm';
import BreadCrumb from '../../components/BreadCrumb/BreadCrumb';
import AuthFooter from '../../components/ui/AuthFooter/AuthFooter';

const LoginPage = () => {
    return (
        <div>
            <BreadCrumb />
            <LoginForm />
            <AuthFooter />
        </div>
    );
};

export default LoginPage;